import script from "./EditLearningDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditLearningDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditLearningDialog.vue?vue&type=style&index=0&id=525adf81&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525adf81"]])

export default __exports__